import PropTypes from 'prop-types';
import EditPersonalTrainingDialog from './EditPersonalTrainingDialog';
import NewPersonalTrainingDialog from './NewPersonalTrainingDialog';

// ----------------------------------------------------------------------

export default function PersonalTrainingDialog(props) {

  return props.id ? <EditPersonalTrainingDialog {...props} /> : <NewPersonalTrainingDialog {...props} />;
}

PersonalTrainingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.number
};
